import { CharmanderSdkProvider, ConnectManager, Trace, WalletConnect } from 'charmander-sdk'
import { WalletClient } from 'viem'
import { BrowserProvider } from 'ethers6'

import { useEffect, useMemo } from 'react'
import { useWalletClient } from 'wagmi'
import { mantle, mantleTestnet } from '@pancakeswap/address-config'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { getMasterChefV3Contract } from 'utils/contractHelpers'

Trace.setDebugShow(false)
Trace.setLogShow(false)

function updateInitConfig(env: string) {
  const config = CharmanderSdkProvider.currentENV
  if (config !== env) {
    CharmanderSdkProvider.initConfig(env as any)
    // console.log('updateInitConfig', env)
  }
}

function updateAccount(walletClient: WalletClient) {
  const { chain, transport } = walletClient
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  }
  const provider = new BrowserProvider(transport as any, network)
  ConnectManager.connect(new WalletConnect(provider, provider))
  // console.log('updateAccount', walletClient.account.address)
}

function disConnect() {
  if (CharmanderSdkProvider.checkConnect()) {
    try {
      CharmanderSdkProvider.disconnect()
      // console.log('disconnect')
    } catch (e) {
      console.error(e)
    }
  }
}

// interface AgniSdkProvider{
//   provider: CharmanderSdkProvider
// }

export function useAgniSDK() {
  const { data: walletClient } = useWalletClient()
  const { chainId } = useActiveChainId()
  useEffect(() => {
    if (chainId === mantleTestnet.id) {
      updateInitConfig('test')
      disConnect()
    }
    if (chainId === mantle.id) {
      updateInitConfig('prod')
      disConnect()
    }
    if (!walletClient) {
      disConnect()
      return
    }
    if (CharmanderSdkProvider.checkConnect()) {
      if (CharmanderSdkProvider.connect().account.toLowerCase() !== walletClient.account.address.toLowerCase()) {
        updateAccount(walletClient)
      }
    } else {
      updateAccount(walletClient)
    }
  }, [chainId, walletClient])

  return useMemo(() => CharmanderSdkProvider, [chainId, walletClient])
}
